<div class="info-bar-parent">
  <mat-card class="info-bar-text">{{text}}</mat-card>
</div>
